<template>
  <v-app>
    <v-main class="white">
      <v-container fluid>
        <v-row>
          <v-col>
            <v-card elevation="0" min-height="79.7vh">
              <div class="d-flex justify-center">
                <v-sheet class="circle" outlined>
                  <v-img
                    :src="businessNetwork.qrCodeURL"
                    max-height="60"
                    max-width="60"
                  />
                </v-sheet>
              </div>
              <div class="text-center">
                <div class="text-subtitle-1">
                  Share your contact details with
                </div>
                <div class="text-subtitle-1">
                  {{ businessProfile.businessName }}
                </div>
              </div>
              <v-card-text>
                <v-row>
                  <v-col class="myForm" cols="12" md="12" sm="12" lg="12">
                    <v-form ref="registrantForm">
                      <div
                        v-if="businessNetwork.isNameSwitchedOn"
                        class="text-subtitle-2"
                      >
                        First Name
                      </div>

                      <v-text-field
                        v-model="newRegistrant.firstName"
                        v-if="businessNetwork.isNameSwitchedOn"
                        label="First Name"
                        single-line
                        placeholder="First Name"
                        validate-on-blur
                        :rules="
                          businessNetwork.isNameRequired ? requiredRules : []
                        "
                        dense
                      />
                      <div
                        v-if="businessNetwork.isNameSwitchedOn"
                        class="text-subtitle-2"
                      >
                        Last Name
                      </div>
                      <v-text-field
                        v-if="businessNetwork.isNameSwitchedOn"
                        v-model="newRegistrant.lastName"
                        label="Last Name"
                        single-line
                        validate-on-blur
                        :rules="
                          businessNetwork.isNameRequired ? requiredRules : []
                        "
                        placeholder="First Name"
                        dense
                      />
                      <div
                        v-if="businessNetwork.isCitySwitchedOn"
                        class="text-subtitle-2"
                      >
                        City
                      </div>
                      <v-text-field
                        v-model="newRegistrant.city"
                        v-if="businessNetwork.isCitySwitchedOn"
                        validate-on-blur
                        :rules="
                          businessNetwork.isCityRequired ? requiredRules : []
                        "
                        label="City"
                        single-line
                        placeholder="City"
                        dense
                      />
                      <div
                        v-if="businessNetwork.isCountrySwitchedOn"
                        class="text-subtitle-2"
                      >
                        Country
                      </div>
                      <v-text-field
                        v-model="newRegistrant.country"
                        v-if="businessNetwork.isCountrySwitchedOn"
                        label="Country"
                        validate-on-blur
                        :rules="
                          businessNetwork.isCountryRequired ? requiredRules : []
                        "
                        single-line
                        placeholder="Country"
                        dense
                      />
                      <div
                        v-if="businessNetwork.isEmailSwitchedOn"
                        class="text-subtitle-2"
                      >
                        Email
                      </div>
                      <v-text-field
                        v-model="newRegistrant.email"
                        v-if="businessNetwork.isEmailSwitchedOn"
                        label="Email"
                        validate-on-blur
                        :rules="
                          businessNetwork.isEmailRequired ? requiredRules : []
                        "
                        single-line
                        placeholder="Email"
                        dense
                      />
                      <div
                        v-if="businessNetwork.isMobileSwitchedOn"
                        class="text-subtitle-2"
                      >
                        Mobile
                      </div>
                      <v-text-field
                        v-model="newRegistrant.mobile"
                        v-if="businessNetwork.isMobileSwitchedOn"
                        validate-on-blur
                        :rules="
                          businessNetwork.isMobileRequired
                            ? mobileRules.concat(requiredRules)
                            : mobileRules
                        "
                        label="Mobile"
                        single-line
                        placeholder="Mobile"
                        dense
                      />
                      <div
                        v-if="businessNetwork.isBusinessNameSwitchedOn"
                        class="text-subtitle-2"
                      >
                        Business Name
                      </div>
                      <v-text-field
                        v-model="newRegistrant.businessName"
                        validate-on-blur
                        :rules="
                          businessNetwork.isBusinessNameRequired
                            ? requiredRules
                            : []
                        "
                        v-if="businessNetwork.isBusinessNameSwitchedOn"
                        label="businessName"
                        single-line
                        placeholder="Business Name"
                        dense
                      />
                      <div
                        v-if="businessNetwork.isJobTitleSwitchedOn"
                        class="text-subtitle-2"
                      >
                        Job Title
                      </div>
                      <v-text-field
                        v-model="newRegistrant.jobTitle"
                        validate-on-blur
                        :rules="
                          businessNetwork.isJobTitleRequired
                            ? requiredRules
                            : []
                        "
                        v-if="businessNetwork.isJobTitleSwitchedOn"
                        label="jobTitle"
                        single-line
                        placeholder="Job Title"
                        dense
                      />
                      <div
                        v-if="businessNetwork.isNoteSwitchedOn"
                        class="text-subtitle-2"
                      >
                        Note
                      </div>
                      <v-textarea
                        v-model="newRegistrant.note"
                        validate-on-blur
                        :rules="
                          businessNetwork.isNoteRequired
                            ? limitRules.concat(requiredRules)
                            : limitRules
                        "
                        v-if="businessNetwork.isNoteSwitchedOn"
                        auto-grow
                        counter
                        placeholder="Leave a note if you’d like more information"
                        rows="1"
                      />
                      <br />
                      <v-btn
                        width="85vw"
                        depressed
                        large
                        class="primary submit-btn"
                        @click="handleSubmit"
                      >
                        Submit
                      </v-btn>

                      <div class="text-center my-5">
                        By clicking Submit, you agree to Pappyon collecting your
                        information for the sole purpose of sending your
                        information to {{ businessProfile.businessName }}
                        who agrees to use it according to their privacy policy
                        <!-- who
                        agrees to use it according to their privacy policy. View
                        <a
                          :href="businessNetwork.privacyPolicyURL"
                          target="_blank"
                          >{{ businessProfile.businessName }} Privacy Policy.</a
                        > -->

                        <a :href="this.privacyPolicyUrl" target="_blank">
                          View Pappyon’s Privacy Policy.</a
                        >
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-dialog v-model="sheet">
                <v-sheet color="white" height="70vh" class="rounded-lg">
                  <div class="text-center">
                    <v-avatar color="#FDE1D6" class="mt-10" size="70">
                      <v-icon dark color="primary" large> mdi-check </v-icon>
                    </v-avatar>
                    <br />
                    <div class="text-title-2 font-weight-bold text-center pa-5">
                      Your information has been shared with <br />{{
                        businessProfile.businessName
                      }}
                    </div>

                    <div class="text-subtitle-1 grey--text text-center pa-5">
                      Connect with {{ businessProfile.businessName }} on the
                      Pappyon app to stay updated and connected!
                    </div>

                    <v-btn
                      width="85vw"
                      depressed
                      large
                      class="primary"
                      @click="handleOpenPappyonApp"
                    >
                      Connect on Pappyon app
                    </v-btn>

                    <v-btn
                      text
                      width="85vw"
                      color="primary"
                      @click="handleClose"
                      depressed
                      large
                    >
                      Not now
                    </v-btn>
                  </div>
                </v-sheet>
              </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TextFieldTitle from "@/components/TextFieldTitle";
import AvatarButton from "@/components/AvatarButton";
import {getBusinessProfilesDoc, getYourBusinessNetworkDoc, updateYourBusinessNetworkDoc} from "@/shared/firebase_utils";
import {arrayUnion} from "firebase/firestore";
let uuid = require("uuid");

export default {
  async created() {
    this.businessNetworkId = this.$route.params.id;
    let bNDocRef = await getYourBusinessNetworkDoc(this.businessNetworkId);

    if (bNDocRef.exists) {
      this.businessNetwork = bNDocRef.data();
      this.registrants = this.businessNetwork.registrants;
      this.businessProfileId = this.businessNetwork.businessProfileId;
    }

    let bPDocRef = await getBusinessProfilesDoc(this.businessProfileId);

    if (bPDocRef.exists) {
      this.businessProfile = bPDocRef.data();
    }

    console.log(this.newRegistrant);
  },
  components: {
    TextFieldTitle,
    AvatarButton,
  },
  data() {
    return {
      businessProfileId: "",
      businessProfile: {},
      newRegistrant: {},
      registrants: [],
      businessNetwork: {},
      requiredRules: [(v) => !!v || "This field is required"],
      limitRules: [
        (v) =>
          (v || "").length <= 200 ||
          "Description must be 200 characters or less",
      ],
      mobileRules: [(v) => /^\d+$/.test(v) || "Invalid mobile number"],
      isFormValid: false,
      sheet: false,
    };
  },
  computed: {
    ...mapGetters(["privacyPolicyUrl"]),
  },
  methods: {
    async handleSubmit() {
      try {
        if (this.$refs.registrantForm.validate()) {
          this.newRegistrant.id = uuid.v1();
          this.newRegistrant.created = new Date().toISOString();


          // Update the "registrants" property of the document
          await updateYourBusinessNetworkDoc(this.businessNetworkId, {
            registrants: arrayUnion(
                this.newRegistrant
            ),
          });

          this.$router.push({
            name: "FormSuccessPage",
            params: { id: this.businessNetworkId },
          });
        } else {
          console.log("form is invalid");
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleClose() {
      this.sheet = false;
      this.clearForm();
    },
    clearForm() {
      this.newRegistrant = {};
    },
    handleOpenPappyonApp() {
      window.open("https://card.pappyon.com/eTUwyDANusKm7KMV8");
    },
  },
};
</script>

<style>
@media (min-width: 1025px) {
  .myForm {
    margin-left: 25vw;
    max-width: 50vw;
  }
  .submit-btn {
    max-width: 50vw;
  }
}
</style>